import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { STEPS } from "@/data/content";

const EASE = [0.76, 0, 0.24, 1];

export const HowItWorks = () => {
  return (
    <section data-testid="how-section" className="bg-[#111111] py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <span className="font-mono-t text-xs uppercase tracking-[0.25em] text-[#FF4444]">
            / 05 — Como Funciona
          </span>
          <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none tracking-tight text-white sm:text-6xl">
            Simples e rápido
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-px border border-white/10 bg-white/10 md:grid-cols-3">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              data-testid={`step-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08, ease: EASE }}
              className="group relative overflow-hidden bg-[#111111] p-8 transition-colors duration-300 hover:bg-[#161616]"
            >
              <span className="pointer-events-none absolute -right-2 -top-6 font-display text-8xl font-bold leading-none text-white/[0.04] transition-colors duration-300 group-hover:text-[#D50000]/10">
                {s.n}
              </span>
              <div className="relative z-10">
                <span className="font-mono-t text-sm text-[#D50000]">{s.n}</span>
                <h3 className="mt-3 font-display text-2xl font-semibold uppercase tracking-tight text-white">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-zinc-400">{s.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
